import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import DeleteGatewayFormModal from 'src/features/gateway/components/form/DeleteGatewayFormModal';
import UpdateGatewayFormModal from 'src/features/gateway/components/form/UpdateGatewayFormModal';
import { Gateway } from 'src/features/gateway/utils/types';
import { gatewayMessages } from 'src/features/gateway/utils/messages';
import { PATH } from 'src/features/navigation/utils/constants';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { PERMISSION } from 'src/features/auth';

export default function CellGatewayActions({ row }: CellContext<Gateway, unknown>) {
    const { formatMessage } = useIntl();
    const manageGateways = useHasPermissions([PERMISSION.MANAGE_GATEWAYS]);

    return (
        <div className="flex gap-1">
            <TooltipProvider>
                {manageGateways && (
                    <>
                        <Tooltip>
                            <UpdateGatewayFormModal
                                selectedGateway={row.original}
                                semantics={{ entryName: formatMessage(gatewayMessages.gateway).toLowerCase() }}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                    </Button>
                                </TooltipTrigger>
                            </UpdateGatewayFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.edit} />
                            </TooltipContent>
                        </Tooltip>
                        <Tooltip>
                            <DeleteGatewayFormModal
                                selectedGateway={row.original}
                                semantics={{ entryName: formatMessage(gatewayMessages.gateway).toLowerCase() }}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                    </Button>
                                </TooltipTrigger>
                            </DeleteGatewayFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.delete} />
                            </TooltipContent>
                        </Tooltip>
                    </>
                )}
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/${PATH.ADMINISTRATION}/gateway/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
